import { render, staticRenderFns } from "./YesCancelDialog.vue?vue&type=template&id=310c1439"
import script from "./YesCancelDialog.vue?vue&type=script&lang=js"
export * from "./YesCancelDialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports